export const tr = {
    'banner-required-href-turbo-vcard-organization':
        "Sitenizin bağlantısını girin, Turbo sayfa oluşturun, vCard bilgilerinizi girin veya Yandex.Rehber'den kurum ekleyin",
    'organization-not-found': "Seçilen kurum Yandex.Rehber'de bulunamadı"
};
